import { render, staticRenderFns } from "./block-ranking.vue?vue&type=template&id=4bd362a0&scoped=true&"
import script from "./block-ranking.vue?vue&type=script&lang=js&"
export * from "./block-ranking.vue?vue&type=script&lang=js&"
import style0 from "./block-ranking.vue?vue&type=style&index=0&id=4bd362a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd362a0",
  null
  
)

export default component.exports